export default {
  sm: `
  빠른 복구와<br /> 후속 조치
  `,
};  